import { createRoute, redirect, type AnyRoute } from "@tanstack/react-router";
import { TrendingUp } from "lucide-react";

import type { FeatureModule } from "@/features/types";
import { guarded } from "@/lib/auth";

import { CroForecastAdminPage } from "./pages/AdminPage";
import { CroForecastAeDetailPage } from "./pages/AeDetailPage";
import { CroForecastDealHealthPage } from "./pages/DealHealthPage";
import { CroForecastForecastMeetingPage } from "./pages/ForecastMeetingPage";
import { CroForecastHowToPage } from "./pages/HowToPage";
import { CroForecastOpenDealsPage } from "./pages/OpenDealsPage";
import { CroForecastPipelineMovementPage } from "./pages/PipelineMovementPage";
import { CroForecastReconcileDealsPage } from "./pages/ReconcileDealsPage";
import { CroForecastSummaryPage } from "./pages/SummaryPage";
import { CroForecastTopOfFunnelPage } from "./pages/TopOfFunnelPage";
import { CroForecastWeeklyKpiPage } from "./pages/WeeklyKpiPage";
import { validateCroForecastSearch } from "./search";

export const croForecastModule: FeatureModule = {
  key: "cro_forecast",
  nav: {
    label: "CRO Forecast",
    icon: TrendingUp,
    to: "/cro-forecast/summary",
    requires: "cro_forecast.read",
    order: 120,
    group: "Strategy",
  },
  routes: (rootRoute) => [
    // Bare /cro-forecast → /cro-forecast/summary
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/cro-forecast",
      beforeLoad: () => {
        throw redirect({ to: "/cro-forecast/summary" });
      },
      component: () => null,
    }),
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/cro-forecast/summary",
      component: guarded("cro_forecast.read", CroForecastSummaryPage),
      validateSearch: validateCroForecastSearch,
    }),
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/cro-forecast/weekly-kpi",
      component: guarded("cro_forecast.read", CroForecastWeeklyKpiPage),
      validateSearch: validateCroForecastSearch,
    }),
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/cro-forecast/forecast-meeting",
      component: guarded("cro_forecast.read", CroForecastForecastMeetingPage),
      validateSearch: validateCroForecastSearch,
    }),
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/cro-forecast/pipeline-movement",
      component: guarded("cro_forecast.read", CroForecastPipelineMovementPage),
      validateSearch: validateCroForecastSearch,
    }),
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/cro-forecast/top-of-funnel",
      component: guarded("cro_forecast.read", CroForecastTopOfFunnelPage),
      validateSearch: validateCroForecastSearch,
    }),
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/cro-forecast/deals",
      component: guarded("cro_forecast.read", CroForecastOpenDealsPage),
      validateSearch: validateCroForecastSearch,
    }),
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/cro-forecast/deal-health",
      component: guarded("cro_forecast.read", CroForecastDealHealthPage),
      validateSearch: validateCroForecastSearch,
    }),
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/cro-forecast/admin",
      component: guarded("cro_forecast.admin", CroForecastAdminPage),
      validateSearch: validateCroForecastSearch,
    }),
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/cro-forecast/how-to",
      component: guarded("cro_forecast.write", CroForecastHowToPage),
      validateSearch: validateCroForecastSearch,
    }),
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/cro-forecast/reconcile-deals",
      component: guarded("cro_forecast.write", CroForecastReconcileDealsPage),
      validateSearch: validateCroForecastSearch,
    }),
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/cro-forecast/ae/$repId",
      component: guarded("cro_forecast.read", CroForecastAeDetailPage),
      validateSearch: validateCroForecastSearch,
    }),
    // Backwards-compat redirects
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/cro_forecast",
      beforeLoad: () => {
        throw redirect({ to: "/cro-forecast/summary" });
      },
      component: () => null,
    }),
  ] as unknown as AnyRoute[],
};
